import React from "react";
import { ErrorMessage } from "react-hook-form";

const Input = React.forwardRef(
  (
    {
      label,
      remove,
      name,
      type,
      placeholder,
      value,
      onChange,
      onRemove,
      errors,
      startAdornment: StartAdornment,
      forceUpdate,
      ...rest
    },
    ref
  ) => {
    return (
      <>
        {label && (
          <div className="flex justify-between items-center">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor={name}>
              {label}
            </label>
            {remove && (
              <button type="button" onClick={onRemove} tabIndex="-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke=""
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="stroke-current text-red-500">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="9" y1="9" x2="15" y2="15"></line>
                  <line x1="15" y1="9" x2="9" y2="15"></line>
                </svg>
              </button>
            )}
          </div>
        )}
        <div className="relative">
          <input
            {...rest}
            className={`appearance-none block w-full bg-gray-200 border ${
              errors[name] ? "border-red-500" : "border-gray-200"
            } rounded py-3 ${
              StartAdornment ? "pl-8 pr-4" : "px-4"
            } leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
              rest.disabled
                ? "text-gray-500 cursor-not-allowed"
                : "text-gray-700"
            }`}
            key={`input-${forceUpdate}`}
            id={name}
            name={name}
            type={type}
            step="any"
            placeholder={placeholder}
            defaultValue={value}
            ref={ref}
            onChange={onChange || rest.onChange}
          />
          {StartAdornment && <StartAdornment />}
        </div>
        {errors[name] ? (
          <ErrorMessage
            errors={errors}
            name={name}
            message="Please fill out this field"
            as="p"
            className="text-red-500 text-xs italic"
          />
        ) : (
          <p style={{ height: 18 }}></p>
        )}
      </>
    );
  }
);

export default Input;
